import { render, staticRenderFns } from "./SubscriptionCard.vue?vue&type=template&id=5cf20d7a&scoped=true&"
import script from "./SubscriptionCard.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf20d7a",
  null
  
)

export default component.exports